import React from 'react'
import compose from 'recompose/compose'
import { graphql } from 'react-apollo'
import { Row, Col, Spin } from 'antd'
import runQuery from '~/App/graphql/queries/run.gql'
// import _keyBy from 'lodash/keyBy'
import _get from 'lodash/get'
import { inject, observer } from 'mobx-react'
// const layout = {
//   labelCol: { sm: { span: 10 }, xs: { span: 24 } },
//   wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
// }

const Run = compose(
  inject('i18n'),
  graphql(runQuery, {
    options: ({ runId }) => ({
      variables: {
        _id: runId
      }
    }),
    skip: ({ runId }) => !runId
  }),
  observer
)(({ data, loading, i18n: { locale } }) => {
  const { run } = data
  // TODO: no need to check settings, can check undefined/null
  if (loading) {
    return <div className="modLoadding">
      <Spin tip="Loading..." size="large" />
    </div>
  }
  if (!run) return <div>Run not found</div>

  // const vrSettings = _get(run, 'ticketType.settings.virtualRun')
  // const fields = _get(vrSettings, 'fields', [])
  // const enabledFields = _keyBy(fields.filter(f => f.enabled), '_id')

  return <div style={{ marginTop: 18 }}>
    {run.distance &&
      <Row>
        <Col span={12} style={{ textAlign: 'right' }}>{{ en: 'Distance', zh: 'Distance', th: 'ระยะทาง' }}: </Col>
        <Col span={12} >{run.distance}</Col>
      </Row>
    }
    {run.activityImage && <div style={{ marginBottom: 6 }}><img src={_get(run, 'activityImage.thumbnail.url')} alt="activity" style={{ maxWidth: '100%' }} /></div>}
    {run.runnerImage && <div style={{ marginBottom: 6 }}><img src={_get(run, 'runnerImage.thumbnail.url')} alt="activity" style={{ maxWidth: '100%' }} /></div>}
  </div>
})

export default Run



// WEBPACK FOOTER //
// ./src/App/components/Run.js